import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Inject } from '@angular/core';
import { ENVIRONMENT } from '@libs/shared/model/environment.token';
import { Observable } from 'rxjs';

import { EnvironmentConfigService } from '../environment/environment-config.service';
import { Environment } from '../environment/environment.model';
import { UtilsService } from '../commons/utils.service';

/**
 * This class is only used to override original api url from the config file with the url
 * specified in the environment.ts file
 */
export class HttpApiUrlOverrideInterceptorService implements HttpInterceptor {
  private _apiUrlOverrideList: { [originUrl: string]: string };
  constructor(
    @Inject(ENVIRONMENT) private environment: Environment,
    private environmentConfigService: EnvironmentConfigService
  ) {
    if (environment.customProps && environment.customProps.apis) {
      this._apiUrlOverrideList = UtilsService.createApiServiceUrlOverrideList(
        environmentConfigService.getEnvironmentConfigs().apis,
        environment.customProps.apis
      );
    }
  }
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (
      this._apiUrlOverrideList &&
      Object.keys(this._apiUrlOverrideList).length > 0
    ) {
      const originalApiUrl = Object.keys(this._apiUrlOverrideList).find((url) =>
        request.url.startsWith(url)
      );
      if (originalApiUrl) {
        return next.handle(
          this.overrideRequestUrl(
            request,
            originalApiUrl,
            this._apiUrlOverrideList[originalApiUrl]
          )
        );
      }
    }
    return next.handle(request);
  }
  overrideRequestUrl(
    req: HttpRequest<any>,
    originalUrl: string,
    destUrl: string
  ): HttpRequest<any> {
    return req.clone({ url: req.url.replace(originalUrl, destUrl) });
  }
}
